import { render, staticRenderFns } from "./MHome.vue?vue&type=template&id=b9b1e3fe&scoped=true&"
import script from "./MHome.vue?vue&type=script&lang=js&"
export * from "./MHome.vue?vue&type=script&lang=js&"
import style0 from "./MHome.vue?vue&type=style&index=0&id=b9b1e3fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b1e3fe",
  null
  
)

export default component.exports